import React from 'react';
import ReactECharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

export const VerticalBarChartNOC = ({
  data = [225, 222, 224],
  name = 'name',
  width = '400px',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const option = {
    title: {
      text: name, // Tiêu đề biểu đồ
      left: 'center',
      top: '90%',
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#5470c6',
      },
    },
    grid: {
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['L1', 'L2', 'L3'], // Tên các cột
      axisLine: {
        // Tùy chỉnh trục X
        lineStyle: {
          color: isAdminRoute, // Màu trục X
        },
      },
      axisTick: { show: false }, // Ẩn dấu gạch trục X
    },
    yAxis: {
      type: 'value',
      axisLine: {
        // Tùy chỉnh trục Y
        lineStyle: {
          color: isAdminRoute, // Màu trục Y
        },
      },
      splitLine: { show: false }, // Ẩn đường lưới ngang
    },
    series: [
      {
        data: data, // Dữ liệu tương ứng cho L1, L2, L3
        type: 'bar',
        itemStyle: {
          color: 'rgba(91, 155, 213, 0.7)', // Màu cột dạng trong suốt
        },
        barWidth: '30%', // Độ rộng cột
      },
    ],
    tooltip: {
      trigger: 'axis',
    },
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: '250px', width }}
      onEvents={() => {}}
    />
  );
};
